import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { name: '首页', path: '/' },
      { name: '电影网站', path: '/category/movie' },
      { name: '剧集网站', path: '/category/series' },
      { name: '动漫网站', path: '/category/anime' },
    ],
  },
  {
    title: '资源分类',
    links: [
      { name: '综艺节目', path: '/category/variety' },
      { name: '纪录片', path: '/category/documentary' },
      { name: '精选文章', path: '/#articles' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌介绍', path: '/about' },
      { name: '联系方式', path: '/about#contact' },
      { name: '用户口碑', path: '/about#reputation' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                看片网站推荐
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              精选最受欢迎的免费在线看片网站，涵盖高清电影、热播剧集、综艺纪录片等海量资源，助你畅享极致观影体验。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2025 看片网站推荐. 本站仅提供网站导航服务，不存储任何影视资源。
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}